import { customAuthenticationService } from '@/services/custom-authentication';
import { useMutation } from '@tanstack/react-query';

interface ForgotPasswordResult {
  success: boolean;
  message?: string;
  error?: string;
}

export const useCustomAuthenticationForgotPassword = () => {
  return useMutation<ForgotPasswordResult, Error, string>({
    mutationFn: async (email: string) => {
      const result = await customAuthenticationService.forgotPassword(email);
      if (!result.success) {
        throw new Error(result.error || 'Erro ao enviar email de recuperação');
      }

      return result;
    },
    retry: 2,
    retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};
